import PermissionWrapper from "components/Shared/Common/PermissionWrapper"
import DeleteConfirmationModal from "components/Shared/ConfirmationModal/DeleteConfirmationModal"
import HeaderCTA from "components/Shared/HeaderFilters/HeaderCTA"
import HeaderFilters from "components/Shared/HeaderFilters/HeaderFilters"
import SearchBox from "components/Shared/HeaderFilters/SearchBox"
import { MFI_MODULE } from "constants/constants"
import { useAppSelector } from "hooks/hooksStore"
import { BaseXlsForm as BaseXlsFormType } from "interfaces/dataInterfaces"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import {
  useDeleteXlsFormSchemaMutation,
  useDownloadJsonSchemasByIdMutation,
  useDownloadXlsFormSchemasByIdMutation,
  useGetBaseXlsFormQuery,
  useGetXlsFormSchemasByIdQuery,
} from "services/mfi/xlsFormSchemas"
import { getSkip, getTop } from "./baseXlsFormSlice"
import DetailsModal from "./DetailsModal"
import Table from "./Table"

const permissionsProps = {
  moduleId: MFI_MODULE,
  subModule: "baseXLSForms",
}

export default function MFIBaseXlsForm() {
  const navigate = useNavigate()

  const top = useAppSelector(getTop)
  const skip = useAppSelector(getSkip)

  const [query, setQuery] = useState<string>("")
  const [actionItem, setActionItem] = useState<{ action: "delete" | "details"; data: BaseXlsFormType } | null>(null)

  const { data, isFetching } = useGetBaseXlsFormQuery({
    search: query,
    skip,
    take: top,
  })
  const [deleteSchema, { isLoading: isDeleting }] = useDeleteXlsFormSchemaMutation()

  const { data: xls, isLoading: loadingXLS } = useGetXlsFormSchemasByIdQuery(actionItem?.data.xlsFormId ?? 0, {
    skip: actionItem?.action !== "details",
  })

  const [download] = useDownloadXlsFormSchemasByIdMutation()
  const [downloadJson, { isLoading: loadingJson }] = useDownloadJsonSchemasByIdMutation()

  return (
    <>
      <HeaderFilters
        left={<SearchBox onSubmit={setQuery} />}
        right={
          <PermissionWrapper {...permissionsProps} feature="addNew">
            <HeaderCTA onClick={() => navigate("add")} label="Add New Base XLSForm Schema" />
          </PermissionWrapper>
        }
      />

      <Table
        {...{ data }}
        isFetching={isFetching || isDeleting}
        onDeleteClick={dataOnDelete => setActionItem({ action: "delete", data: dataOnDelete })}
        onDetailsClick={dataOnClick => setActionItem({ action: "details", data: dataOnClick })}
        permissionsParams={permissionsProps}
      />

      <DeleteConfirmationModal
        open={actionItem?.action === "delete"}
        onRequestClose={() => setActionItem(null)}
        onRequestSubmit={() => {
          deleteSchema(actionItem?.data.xlsFormId as number)
          setActionItem(null)
        }}
      />

      {actionItem?.action === "details" && (
        <DetailsModal
          title="Base XLS Form Infos"
          xls={xls}
          loading={loadingXLS || loadingJson}
          download={download}
          downloadJSON={downloadJson}
          isOpen={actionItem.action === "details"}
          onClose={() => setActionItem(null)}
          module="mfi"
        />
      )}
    </>
  )
}
